// removed by extract-text-webpack-plugin
module.exports = {"currencyinformation-wrapper":"currencyinformation-wrapper__1oBXo","currencyinformation-title":"currencyinformation-title__6UPjO","currencyinformation-img":"currencyinformation-img__3as4R","Currencyinformation-code":"Currencyinformation-code__1KZXb","Currencyinformation-name":"Currencyinformation-name__177FK","Currencyinformation-description":"Currencyinformation-description__302iU"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/components/Aboutcurrenies/CurrencyInformation/CurrencyInformation.scss
// module id = 581
// module chunks = 68